import { render, staticRenderFns } from "./NewsList_test.vue?vue&type=template&id=1d8a7867&"
import script from "./NewsList_test.vue?vue&type=script&lang=js&"
export * from "./NewsList_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports